/* @flow */

export default {
  'img, video': {
    // Remove the gap between the element and the bottom of the container
    // Ref: https://github.com/h5bp/html5-boilerplate/issues/440
    verticalAlign: 'middle',

    maxWidth: '100%',

    '&[width], &[height]': {
      // Respect the dimensions set in the `width` and `height` attributes
      // if any
      maxWidth: 'none',
    },
  },
};
